import { resolveJigsawTemplateTileSize } from "./jigsawScreenshotUtils";

/** Extract `{ story, storyJigsaw, templates }` from decrypted jigsaw group payloads. */
export function normalizeHomeJigsawGroup(raw) {
    if (!raw || typeof raw !== "object") return null;
    if (raw.code === "FAILURE") return null;

    const extract = (o) => {
        if (!o || typeof o !== "object") return null;
        const templates = Array.isArray(o.templates) ? o.templates : [];
        const story = o.story ?? null;
        const sid = o.storyId ?? o.story_id ?? story?.id ?? null;
        if (!story && templates.length === 0 && !sid) return null;

        const sj = o.storyJigsaw ?? o.story_jigsaw ?? null;
        let storyJigsaw = null;
        if (sj && typeof sj === "object") {
            storyJigsaw = {
                id: sj.id ?? null,
                free: sj.free === true,
                publishedAt: sj.publishedAt ?? sj.published_at ?? null,
                state: sj.state ?? null,
                disabledAt: sj.disabledAt ?? sj.disabled_at ?? null,
            };
        }

        const normalizedTemplates = templates.map((t) => {
            if (!t || typeof t !== "object") return t;
            const base = {
                ...t,
                tileSize: t.tileSize ?? t.tile_size ?? null,
                difficultyLevel: t.difficultyLevel ?? t.difficulty_level ?? null,
                templateName: t.templateName ?? t.template_name ?? t.name ?? null,
            };
            const resolvedTile = resolveJigsawTemplateTileSize(base);
            return {
                ...base,
                tileSize: resolvedTile > 0 ? resolvedTile : base.tileSize,
            };
        });

        const userPlays = Array.isArray(o.userPlays)
            ? o.userPlays
            : Array.isArray(o.user_plays)
              ? o.user_plays
              : null;

        return {
            storyId: typeof sid === "string" ? sid.trim() : sid,
            story,
            storyJigsaw,
            templates: normalizedTemplates,
            ...(userPlays ? { userPlays } : {}),
            puzzleTemplate: o.puzzleTemplate ?? o.puzzle_template ?? null,
        };
    };

    const direct = extract(raw);
    if (direct) return direct;

    const nestedKeys = ["data", "content", "payload", "body", "result", "jigsawStoryGroup"];
    for (const key of nestedKeys) {
        const inner = raw[key];
        if (inner && typeof inner === "object") {
            const u = extract(inner);
            if (u) return u;
        }
    }
    return null;
}
